module.exports = __webpack_public_path__ + "img/empty_shoppingcar.aab3aa7c.png";